






import LegalAgreements from '@/components/Templates/User/Legal/LegalAgreements.vue';

export default {
    name: 'PrivacyPolicy',
    components: {
        LegalAgreements,
    },
};
